import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const ControlsContainer = styled.div`
	display: flex;
	align-items: center; 
	justify-content: space-between; 
	gap: 32px; 
	margin-bottom: 32px; 
	width: 100%;

	@media (max-width: 768px) {
		flex-direction: column;
		align-items: center; 
		gap: 16px;
		margin-bottom: 24px;
		justify-content: center; 
	}
`;

export const PostsGrid = styled.div`
	width: 100%; 
	display: grid;

	grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
	gap: 32px; 

	@media (max-width: 768px) {
		gap: 20px; 

		grid-template-columns: 1fr;
	}
`;

export const CreatePostButton = styled(Link)`
	position: fixed;
	bottom: 32px;
	right: 32px;
	padding: 16px 24px;
	background: var(--color-accent, #3498db); 
	color: white;
	text-decoration: none;
	border-radius: 30px;
	font-size: 1em;
	box-shadow: 0 4px 12px rgba(52, 152, 219, 0.3);
	transition: all 0.2s ease;
	z-index: 10; 

	&:hover {
		background: var(--color-accent-dark, #2980b9); 
		transform: translateY(-2px);
		box-shadow: 0 6px 16px rgba(52, 152, 219, 0.4);
	}

	@media (max-width: 768px) {
		bottom: 20px; 
		right: 20px;
		padding: 12px 18px; 
		font-size: 0.9em; 
	}
`;

export const NoPostsMessage = styled.div`
	grid-column: 1 / -1; 
	padding: 40px;
	text-align: center;
	font-style: italic;
	color: #777;
`;
